<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedGradualInjection"
    style="min-width: 220px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Injeção Gradual
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectedGradualInjection: this.value,
      options: [
        { value: 10, text: '10%' },
        { value: 20, text: '20%' },
        { value: 30, text: '30%' },
        { value: 40, text: '40%' },
        { value: 50, text: '50%' },
        { value: 60, text: '60%' },
        { value: 70, text: '70%' },
        { value: 80, text: '80%' },
        { value: 90, text: '90%' },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedGradualInjection);
    },
  },
};
</script>
